import React from 'react';
import { AiOutlineEye, AiOutlineEdit, AiOutlineDelete } from 'react-icons/ai';

const VendorList = () => {
  const Vendors = [
    {
      id: 1,
      name: 'Amit Traders',
      store: 'Amit Store',
      totalSales: '₹15,000',
      products: 120,
      orders: 340,
      reviews: 58,
      inquiries: 12,
      blogs: 5,
      status: 'Active',
      joined: '2025-06-15',
    },
    {
      id: 2,
      name: 'Vaishnavi Creations',
      store: 'VC Store',
      totalSales: '₹10,200',
      products: 98,
      orders: 220,
      reviews: 45,
      inquiries: 9,
      blogs: 3,
      status: 'Pending',
      joined: '2025-06-20',
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">All Vendors</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li className="breadcrumb-item active">Vendors</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title">All Vendor Accounts</h4>
              </div>

              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table align-middle table-hover table-centered mb-0">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th>#</th>
                        <th>Vendor Name</th>
                        <th>Store</th>
                        <th>Total Sales</th>
                        <th>Products</th>
                        <th>Orders</th>
                        <th>Reviews</th>
                        <th>Inquiries</th>
                        <th>Blogs</th>
                        <th>Status</th>
                        <th>Joined</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Vendors.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.name}</td>
                          <td>{item.store}</td>
                          <td>{item.totalSales}</td>
                          <td>{item.products}</td>
                          <td>{item.orders}</td>
                          <td>{item.reviews}</td>
                          <td>{item.inquiries}</td>
                          <td>{item.blogs}</td>
                          <td>
                            <span className={`badge ${item.status === 'Active' ? 'bg-success' : 'bg-warning text-dark'}`}>
                              {item.status}
                            </span>
                          </td>
                          <td>{item.joined}</td>
                          <td>
                            <div className="d-flex gap-2">
                              <button className="btn btn-light btn-sm" title="View">
                                <AiOutlineEye className="fs-5" />
                              </button>
                              <button className="btn btn-primary btn-sm" title="Edit">
                                <AiOutlineEdit className="fs-5" />
                              </button>
                              <button className="btn btn-danger btn-sm" title="Delete">
                                <AiOutlineDelete className="fs-5" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="card-footer text-end">
                <small className="text-muted">Showing {Vendors.length} entries</small>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer mt-4 text-center">
          <div className="container-fluid">© 2025 Vendor Management System</div>
        </footer>
      </div>
    </div>
  );
};

export default VendorList;
